var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1694_8886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 2.00001C11.5086 1.82491 11.7165 1.68602 11.9452 1.59126C12.174 1.4965 12.4192 1.44772 12.6668 1.44772C12.9145 1.44772 13.1596 1.4965 13.3884 1.59126C13.6172 1.68602 13.8251 1.82491 14.0002 2.00001C14.1753 2.1751 14.3142 2.38297 14.4089 2.61175C14.5037 2.84052 14.5524 3.08572 14.5524 3.33334C14.5524 3.58096 14.5037 3.82616 14.4089 4.05494C14.3142 4.28371 14.1753 4.49158 14.0002 4.66668L5.00016 13.6667L1.3335 14.6667L2.3335 11L11.3335 2.00001Z",
    stroke: "#7CAA74",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1694_8886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d1550b60a64c138b127f2293864e7728.svg";
export { ForwardRef as ReactComponent };